import React, { useState } from "react";
import { BsGear } from "react-icons/bs";
import { FaGear } from "react-icons/fa6";
import { PaymentMethods } from "./PaymentMethods";

export const Payout = () => {
  const fakeData = [
    {
      date: "2024-01-15",
      status: "Paid",
      method: "Paypal",
      license: "ABC123",
      price: 49.99,
    },
    {
      date: "2024-01-16",
      status: "Processing",
      method: "Paypal",
      license: "DEF456",
      price: 89.99,
    },
    {
      date: "2024-01-17",
      status: "Paid",
      method: "Stripe",
      license: "GHI789",
      price: 29.99,
    },
    {
      date: "2024-01-18",
      status: "Processing",
      method: "Paypal",
      license: "JKL012",
      price: 99.99,
    },
    {
      date: "2024-01-19",
      status: "Paid",
      method: "Stripe",
      license: "MNO345",
      price: 59.99,
    },
    {
      date: "2024-01-20",
      status: "Processing",
      method: "Stripe",
      license: "PQR678",
      price: 39.99,
    },
    {
      date: "2024-01-21",
      status: "Paid",
      method: "Product G",
      license: "STU901",
      price: 79.99,
    },
    {
      date: "2024-01-22",
      status: "Processing",
      method: "Product H",
      license: "VWX234",
      price: 109.99,
    },
    {
      date: "2024-01-23",
      status: "Paid",
      method: "Product I",
      license: "YZA567",
      price: 69.99,
    },
    {
      date: "2024-01-24",
      status: "Processing",
      method: "Product J",
      license: "BCD890",
      price: 49.99,
    },
  ];

  const [visibleCount, setVisibleCount] = useState(8);
  const [showPaymentMethod, setShowPaymentMethod] = useState(false);

  const handleLoadMore = () => {
    setVisibleCount((prevCount) => prevCount + 2);
  };

  const handleShowLess = () => {
    setVisibleCount(8);
  };

  const handleShowPayment = () => {
    setShowPaymentMethod((prev) => !prev);
  };

  return (
    <div className="w-full lg:px-6 lg:py-4 overflow-x-scroll lg:w-[90%] xl:w-full hidescroll">
      {showPaymentMethod ? (
        <PaymentMethods handleShowPayment={handleShowPayment} />
      ) : (
        <>
          <div
            onClick={handleShowPayment}
            className="cursor-pointer flex items-center justify-between shrink-0"
          >
            <h1 className="text-[28px] md:text-[32px]">Payouts History</h1>
            <div className="flex items-center space-x-2 w-fit bg-[#1c1c1c] shrink-0 rounded-lg dark:bg-white dark:text-[#1c1c1c] text-white  py-2 px-4 ">
              <BsGear />
              <p>Payouts Methods</p>
            </div>
          </div>
          <div className="relative my-4 hidescroll px-2 rounded-lg border-[#F0F0F0] border-[2px] dark:border dark:border-[#3d3d3d] overflow-x-auto md:min-w-[800px] py-2">
            <table className="w-full rounded-lg text-sm text-left rtl:text-right">
              <thead className="text-xs rounded-lg text-gray-700 uppercase dark:text-white dark:bg-[#2F2F2F] bg-[#F2F2F2]">
                <tr>
                  <th scope="col" className="px-6 py-3">
                    DATE
                  </th>
                  <th scope="col" className="px-6 py-3">
                    STATUS
                  </th>
                  <th scope="col" className="px-6 py-3">
                    METHOD
                  </th>
                  <th scope="col" className="px-6 py-3">
                    REFERENCE
                  </th>
                  <th scope="col" className="px-6 py-3">
                    AMOUNT
                  </th>
                </tr>
              </thead>
              <tbody>
                {fakeData.slice(0, visibleCount).map((order, index) => (
                  <tr
                    key={index}
                    className={
                      index === 0 || index !== fakeData.length - 1
                        ? "bg-white border-b border-[#F0F0F0] dark:border-[#3D3D3D] dark:bg-transparent"
                        : ""
                    }
                  >
                    <td className="px-6 py-4">{order.date}</td>
                    <td className="px-6 py-4">
                      <div
                        className={`rounded-lg px-2 py-1 w-fit ${getStatusColor(
                          order.status
                        )}`}
                      >
                        <p>{order.status}</p>
                      </div>
                    </td>
                    <td className="px-6 py-4">{order.method}</td>
                    <td className="px-6 py-4">{order.license}</td>
                    <td className="px-6 py-4">{order.price}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="flex justify-center my-4">
              {visibleCount < fakeData.length ? (
                <button
                  onClick={handleLoadMore}
                  className=" bg-[#1c1c1c] rounded-lg dark:bg-white dark:text-[#1c1c1c] text-white py-2 px-4"
                >
                  Load ({fakeData.length - visibleCount}) more
                </button>
              ) : (
                <button
                  onClick={handleShowLess}
                  className=" bg-[#1c1c1c] rounded-lg dark:bg-white dark:text-[#1c1c1c] text-white  py-2 px-4 "
                >
                  Show less
                </button>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

const getStatusColor = (status) => {
  if (status === "Processing")
    return "bg-[#FFF2B1] text-[#5C4F09] dark:bg-[#5C4F09] dark:text-[#FFE55E]";
  if (status === "Paid")
    return "bg-[#CBF0D0] text-[#1D6528] dark:bg-[#175220] dark:text-gray-200";
  return "";
};
